<template>
  <div class="cs-shipping">
    <section
      v-if="shipping.services.length == 0"
      class="cs-shipping-destination"
    >
      <span class="cs-shipping-name">
        Frete e prazo
      </span>
      <section class="cs-shipping-input">
        <input
          v-model="destinationPostalCode"
          v-mask="'00000-000'"
          type="text"
          placeholder="CEP _____-___"
          maxlength="9"
          @keyup.enter="calculate"
        >
        <button
          class="cs-shipping-button"
          @click="calculate"
        >
          Calcular
        </button>
      </section>
      <a
        href="http://www.buscacep.correios.com.br/sistemas/buscacep"
        target="_blank"
      >
        Não sei o CEP
      </a>
    </section>
    <section
      v-else
      class="cs-shipping-services"
    >
      <section class="cs-shipping-address">
        <span>
          Opções de envio para
          <strong>
            {{ destinationAddress }}
          </strong>
        </span>
        <span
          class="cs-clean-btn"
          @click="clean"
        >
          Alterar
        </span>
      </section>
      <ul>
        <li
          v-for="(service, index) in shipping.services"
          :key="index"
          :class="{ 'cs-shipping-service-active':
            service.value == shipping.price }"
          class="cs-shipping-service"
        >
          <div class="cs-shipping-service-input">
            <input
              :id="service.name"
              v-model="currentService"
              name="currentService"
              type="radio"
              :value="service"
            >
          </div>
          <section class="cs-shipping-service-name">
            <label
              class="cs-shipping-name"
              :for="service.name"
            >
              {{ serviceName(service) }}
            </label>
            <label
              class="cs-shipping-deadline"
              :for="service.name"
            >
              Até {{ service.deadline }} dias
            </label>
          </section>
          <section class="cs-shipping-service-value">
            <label
              :for="service.name"
              v-if="service.value"
            >
              {{ parseCurrency(service.value) }}
            </label>
          </section>
        </li>
      </ul>
    </section>
    <section class="cs-shipping-wrapper">
      <span class="cs-shipping-label">
        Envio
      </span>
      <span
        class="cs-shipping-price"
        :class="freeShippingClass"
      >
        {{ price }}
      </span>
    </section>
  </div>
</template>

<script>
import currencyMixin from '@/mixins/currency'
import { mapState, mapGetters } from 'vuex'

const ERROR_MESSAGES = {
  'invalid_destination_postal_code': `O CEP informado é inválido, por favor
    digite novamente.`,
  'destination_postal_code_not_found': `Não encontramos nenhuma localidade
    com o CEP informado, por favor digite novamente.`,
  'invalid_origin_postal_code': `O CEP da loja é inválido, por favor entre
    em contato com o dono da loja.`,
  'exceeded_weight': `Não foi possível calcular o frete, o peso máximo de
    envio foi excedido.`,
  'unexpected_error': `Não foi possível calcular seu CEP, por favor tente
    novamente.`
}

export default {
  name: 'Shipping',

  mixins: [currencyMixin],

  data() {
    return {
      destinationPostalCode: ''
    }
  },

  computed: {
    ...mapState('cart', ['cart']),
    ...mapState('shipping', ['shipping']),

    destinationAddress() {
      const { city, state, street } = this.shipping.address.destination
      let result = ''

      if(street) result += `${street}, `
      if(city && state) result += `${city} - ${state}, `

      return `${result}CEP: ${this.destinationPostalCode}`
    },

    currentService: {
      get() {
        return this.shipping.currentService
      },

      set(service) {
        this.$store.dispatch('shipping/setCurrentService', service)
      }
    },

    price() {
      const value = this.currentService.value

      switch(value) {
        case undefined:
          return 'Não calculado'
        case null:
          return 'Não calculado'
        case 0:
          return 'Grátis'
        default:
          return this.parseCurrency(value)
      }
    },

    freeShippingClass() {
      return this.shipping.price == 0 ? 'cs-free-shipping' : ''
    }
  },

  watch: {
    destinationPostalCode(newValue) {
      this.$store.dispatch('shipping/setDestinationPostalCode', newValue)
    }
  },

  methods: {
    async calculate() {
      this.$store.dispatch('cart/setLoading', true)

      try {
        await this.$store.dispatch('shipping/calculate', {
          cartId: this.cart.id,
          destinationPostalCode: this.destinationPostalCode
        })
      } catch(error) {
        const errorType = error.message.replace('GraphQL error: ', ''),
          message =
            ERROR_MESSAGES[errorType] || ERROR_MESSAGES['unexpected_error']

        swal('Ops!', message, 'error')
      } finally {
        this.$store.dispatch('cart/setLoading', false)
      }
    },

    clean() {
      this.destinationPostalCode = ''
      this.$store.dispatch('shipping/clean')
    },

    serviceName(service) {
      return service.name == 'free_purchase_value' ?
        'GRÁTIS' : `Correios - ${service.name}`
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_mixins.scss';

.cs-shipping {
  @include phone-only { padding: 5% 2%; }

  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 2%;
  width: 93%;

  .cs-shipping-wrapper {
    @include phone-only { width: 100%; }
    @include tablet-portrait-up { width: 32%; }
    @include tablet-landscape-up { width: 25%; }

    display: flex;
    justify-content: space-between;
  }
}

.cs-shipping-destination, .cs-shipping-services {
  @include phone-only { width: 100%; margin-bottom: 5%; }
  @include tablet-portrait-up { width: 68%; }
  @include tablet-landscape-up { width: 75%; }
}

.cs-shipping-destination {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  .cs-shipping-name {
    margin-bottom: 1%;
    width: 100%;
    text-align: left;
  }

  .cs-shipping-input {
    align-items: center;
    display: flex;
    flex-wrap: wrap;

    input {
      border: 1px solid #ccc;
      border-radius: 4px;
      color: #333;
      font-size: 13px;
      height: 36px;
      padding: 0 30px 0 8px;
      margin-right: 10px;
      width: 120px;
    }

    button {
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
      border-style: solid;
      border-width: 1px;
      box-shadow: none;
      box-sizing: border-box;
      background-color: rgba(255, 255, 255, 1);
      border-color: rgba(52, 152, 219, 1);
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;
      height: 39px;
      width: 76px;
    }
  }

  a {
    color: #000;
    font-size: 12px;
    margin-top: 1%;
    text-align: left;
    text-decoration: none;
    text-decoration: underline;
    width: 100%;
  }
}

.cs-shipping-services {
  display: flex;
  flex-direction: column;

  .cs-clean-btn {
    color: #000;
    cursor: pointer;
    font-size: 14px;
    text-decoration: underline;
  }

  ul {
    @include phone-only { align-items: center; }

    list-style: none;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    padding: 0;

    .cs-shipping-service-active {
      background-color: rgba(52, 73, 94, .1);
    }

    li {
      @include phone-only { padding: 2%; }

      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: center;

      box-sizing: border-box;
      border-width: 1px;
      border-style: solid;
      border-color: rgba(228, 228, 228, 1);
      border-radius: 3px;

      .cs-shipping-service-name {
        @include phone-only { align-items: center; }

        display: flex;
        flex-direction: column;
        align-items: center;
        width: 150px;

        .cs-shipping-name {
          @include phone-only {
            font-size: 15px;
            padding: 3% 0;
            width: 100%;
          }

          font-size: 13px;
        }

        .cs-shipping-deadline {
          @include phone-only { font-size: 15px; }

          color: #797979;
          font-size: 11px;
        }
      }

      .cs-shipping-service-value {
        @include tablet-portrait-up { margin-right: 15px; }
        @include phone-only {
          margin-right: 5px;
          width: 70px;
        }

        width: 60px;

        label {
          @include phone-only { font-size: 15px; }

          font-size: 13px;
        }
      }

      div {
        margin-left: 15px;
      }
    }
  }

  .cs-shipping-address {
    font-size: 14px;
    text-align: left;

    span {
      margin-right: 0.5%;
    }
  }
}

.cs-free-shipping {
  color: #2ad478;
  font-weight: bold;
}
</style>
